import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { AnalyticsProvider, OnetrustProvider, RouteProvider, AnalyticsAttributesProvider } from './components';
import { GlobalStyles } from './styles';
import { Page } from './views';
export const APP_ID = 'BXP-APP';
export function App({ defaultPageModel }) {
    return (_jsx(StrictMode, { children: _jsx(AnalyticsAttributesProvider, Object.assign({ value: {
                eventContainer: 'content',
                path: defaultPageModel.content.route.content.path,
                pageVariant: defaultPageModel.content.variant
            } }, { children: _jsx(RouteProvider, Object.assign({ value: defaultPageModel.content.route.content.path }, { children: _jsx(OnetrustProvider, { children: _jsxs(AnalyticsProvider, { children: [_jsx(GlobalStyles, {}, void 0), _jsx(Page, { model: defaultPageModel }, void 0)] }, void 0) }, void 0) }), void 0) }), void 0) }, void 0));
}
//# sourceMappingURL=app.js.map